<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Miejsce wystawienia</div>
            <div class="text-md text-secondary">Domyślne miejsce wystawienia</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <mat-form-field subscriptSizing="dynamic" class="w-full">
            <input type="text" matInput [formControl]="control" (change)="saveChanges()">
        </mat-form-field>
    </div>
</div>
